import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

type RouteChangeStatus = 'idle' | 'loading' | 'completed'

export const useRouteObserver = () => {
  const location = useLocation()
  const [status, setStatus] = useState<RouteChangeStatus>('idle')

  useEffect(() => {
    // In React Router, route changes are immediate, so we simulate the states
    setStatus('loading')

    const timer = setTimeout(() => {
      setStatus('completed')
    }, 100) // Short delay to simulate loading

    return () => {
      clearTimeout(timer)
    }
  }, [location])

  const isLoading = status === 'loading'
  const isCompleted = status === 'completed'
  const isIdle = status === 'idle'

  return { isLoading, isCompleted, isIdle }
}
